export default "__VITE_ASSET__8670dba0__"